import React from 'react'
import logo from '../../assests/images/footerLogo.png'
import { Link } from 'react-router-dom'
const Footer = () => {
  return (
   <div className="footer">
  <img src={logo} alt="Gamifly Kash" />
  <p>
     Get ready for a gaming experience like no other. Gamifly Kash is your go-to place for endless fun and exciting challenges. It’s more than just a game; it’s a full gaming ecosystem where you can play smart and earn rewards!
  </p>
  <hr />
  <ul>
    {/* <li><Link to={'/Faq'} className='foot'>FAQs</Link></li>
    <li><Link to={'/howplay'} className='foot'>How to Play</Link></li> */}
    <li><Link to={'/Privacy'} className='foot'>Privacy Policy</Link></li>
    <li><Link to={'/tnc'} className='foot'>TnC</Link></li>
    {/* <li>Terms & Conditions</li>
              <li>Privacy Policy</li> */}
  </ul>
  <hr />
  <p>© 2025 Gamifly Kash, All rights reserved.</p>
</div>

  )
}

export default Footer
